import { motion } from "framer-motion"
import { useContext, useEffect, useLayoutEffect, useRef, useState } from "react"

import TopoMenu from "../../../componentes/gerais/TopoMenu"
import MenuLateral from "../../../componentes/gerais/Menu"

import { Campo } from "../../../componentes/form/campo"
import { Spinner } from "../../../componentes/Spinner"

import { MdArrowBackIos, MdCheckCircle, MdCheckCircleOutline } from "react-icons/md"
import { Alert, Backdrop, Card, IconButton, Tab, Tabs } from "@mui/material"
import { configAnim } from "../../../servicos/config/configAnim"

import RelatorioAcertos from "./RelatorioAcertos"
import RelatorioConcluidos from "./RelatorioConcluidos"
import ListagemRelatorio from "./componentes/listagem"

import AppAPI from "./../../../servicos/AppAPI"
import { ContextoGeral } from "../../../contextos/ContextoGeral"
import MensagemApp from "../../../servicos/config/MensagemApp"
import Refresher from "../../../componentes/uteis/Refresher"
import { useLocation } from "react-router-dom"

export default function Relatorios() {
	const [carregando, setCarregando] = useState(true)

	const { state } = useLocation()

	const [tab, setTab] = useState("A")
	const [menu, setMenu] = useState(false)
	const [listaCotacoes, setListaCotacoes] = useState('')

	const [configBuscas, setConfigBuscas] = useState({})

	const [periodo, setPeriodo] = useState('hoje')

	const [backdrop, setBackdrop] = useState(false)
	const [backdropConteudo, setBackdropConteudo] = useState('')

	const { dados, setDados } = useContext(ContextoGeral)
	const [erroAPI, setErroAPI] = useState(false)
	const [scroll, setScroll] = useState(true)

	const mudarTab = (value) => {
		setTab(value)
	}

	const handleBackdrop = (relatorio) => {
		setBackdrop(true)
		let acertos = {}
		acertos.dados = relatorio
		setBackdropConteudo(<ListagemRelatorio acertos={acertos} />)
	}

	async function buscarConfig() {
		try {
			let jsonConfig = await AppAPI.buscarConfigRelatorio(dados)
			console.log('camposRelatorio', jsonConfig)

			if (jsonConfig?.resultado && jsonConfig?.dados?.campos) {
				setConfigBuscas(jsonConfig.dados)
				setErroAPI(false)
			} else {
				setErroAPI(true)
				if (typeof window.AndroidInterface !== 'undefined') {
					window.AndroidInterface.showAndroidVersion(MensagemApp.msgErroApi)
				} else {
					alert(MensagemApp.msgErroApi)
				}
			}
		} catch (e) {
			setErroAPI(true)
			if (typeof window.AndroidInterface !== 'undefined') {
				window.AndroidInterface.showAndroidVersion(MensagemApp.msgErroApi)
			} else {
				alert(MensagemApp.msgErroApi)
			}
		}
		setCarregando(false)
	}

	async function buscarCotacoes() {
		setListaCotacoes(<Spinner />)
		setErroAPI(false)

		let retorno = await AppAPI.buscarRelatorioCotacoes(dados, periodo)

		if (retorno?.codigo) {
			if (retorno?.resultado) {
				if (retorno.dados != '') {
					setListaCotacoes(
						<Card className="bgGradientGrey p-3">
							<div>{retorno.dados.aceitos.label}: {retorno.dados.aceitos.quantidade}</div>
							<div>{retorno.dados.recusados.label}: {retorno.dados.recusados.quantidade}</div>
							<div>{retorno.dados.concluidos.label}: {retorno.dados.concluidos.quantidade}</div>
						</Card>
					)
				} else {
					setListaCotacoes(
						<Alert>
							{retorno.mensagem}
						</Alert>
					)
				}
			} else {
				setListaCotacoes(
					<Alert>
						Nenhuma cotação encontrada
					</Alert>
				)
			}
		} else {

			setErroAPI(true)
			if (typeof window.AndroidInterface !== 'undefined') {
				window.AndroidInterface.showAndroidVersion(MensagemApp.msgErroApi)

			} else {
				alert(MensagemApp.msgErroApi)
			}
		}
	}

	const handleBackdropClose = (event) => {
		setBackdropConteudo('')
		setBackdrop(false)
	}

	const handleCotacaoPeriodo = async (e) => {
		setPeriodo(e.target.value)
	}

	useEffect(() => {
		if (carregando) {
			if (state?.tab && scroll) {
				mudarTab(state.tab)
			}

			buscarConfig()
		}
	}, [carregando])

	useLayoutEffect(() => {
		if (!carregando && state?.tab === "C" && scroll) {
			const scrollContainer = document.querySelector("#tabs")

			if (scrollContainer) {
				scrollContainer.scrollLeft = 500
				setTab("C")
				setScroll(false)
			}
		}
	}, [carregando, state?.tab])



	return (
		<>
			<motion.div
				style={{ height: '100%' }}
				initial={configAnim.initial}
				animate={configAnim.animate}
				exit={configAnim.exit}
				transition={configAnim.transition}
			>
				<TopoMenu voltar="/app/home" titulo="RELATÓRIOS" setShow={setMenu} />
				<div className="mx-2 mt-3">

					{carregando
						? <Spinner />
						: <>
							{erroAPI
								? <>
									<div className="mx-2">
										<Refresher
											setCarregando={setCarregando}
										/>
										<Alert severity="error" className="text-center mt-4">
											{MensagemApp.msgErroApi}
										</Alert>
									</div>
								</>
								: <Tabs
									variant="scrollable"
									onChange={(e, val) => setTab(val)}
									value={tab}
									activeKey={tab}
									id="tabs"
									TabIndicatorProps={{
										style: { display: 'none' } // <-- Remove a linha (indicator)
									}}
								>
									{configBuscas.campos?.cotacoes?.exibicao && <Tab
										value="A"
										className={`${tab === 'A' ? '!bg-[var(--primaria)] !text-white ' : '!bg-gray-200 !text-[var(--primaria)]'} !me-3 !min-w-[120px] !rounded-xl`}
										sx={{ height: '60px' }}
										label={<div className="flex text-lg font-semibold mb-0 py-1 items-center">
											{tab === 'A'
												? <MdCheckCircle />
												: <MdCheckCircleOutline />}
											{configBuscas.campos.cotacoes.label}
										</div>}
									/>}

									{configBuscas.campos?.servicosConcluidos?.exibicao && <Tab
										value="B"
										className={`${tab === 'B' ? '!bg-[var(--primaria)] !text-white' : '!bg-gray-200 !text-[var(--primaria)]'} !me-3 !min-w-[120px] !rounded-xl`}
										sx={{ height: '60px' }}
										label={<div id="tabAcertos" className="flex text-lg font-semibold mb-0 py-1 items-center">
											{tab === 'B'
												? <MdCheckCircle />
												: <MdCheckCircleOutline />}
											{configBuscas.campos.servicosConcluidos.label}
										</div>}
									/>}

									{configBuscas.campos?.acertos?.exibicao && <Tab
										value="C"
										className={`${tab === 'C' ? '!bg-[var(--primaria)] !text-white' : '!bg-gray-200 !text-[var(--primaria)]'} !me-3 !min-w-[120px] !rounded-xl`}
										sx={{ height: '60px' }}
										label={<div className="flex text-lg font-semibold mb-0 py-1 items-center">
											{tab === 'C'
												? <MdCheckCircle />
												: <MdCheckCircleOutline />}
											{configBuscas.campos.acertos.label}
										</div>}
									/>}
								</Tabs>}

							{!erroAPI && tab == "A" && <>
								<div className="my-3">
									<Campo
										tipo="select"
										onChange={handleCotacaoPeriodo}
										value={periodo}
										options={configBuscas.filtros?.cotacoes?.periodo?.opcoes}
									/>
									<div className="g-0 mt-3">
										<button className="w-full" onClick={buscarCotacoes}>Buscar</button>
									</div>
								</div>
								{listaCotacoes}
							</>}
							{!erroAPI && tab == "B" && <RelatorioConcluidos config={configBuscas} origemHome={state} />}
							{!erroAPI && tab == "C" && <RelatorioAcertos config={configBuscas} handleBackdrop={handleBackdrop} />}

						</>}
					<MenuLateral show={menu} setShow={setMenu} ativoRota="/app/relatorios" />
				</div >
			</motion.div >

			<Backdrop
				open={backdrop}
				sx={{
					zIndex: (theme) => theme.zIndex.drawer + 1,
					backgroundColor: "#fff",
					height: '100%',
					overflowY: 'auto',
					display: 'block'
				}}
			>
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
				>
					<div>
						<div
							className="mx-2 mt-2 pt-2 flex items-center gap-2 sticky top-0 bg-white pb-2 border-b border-gray-100"
							style={{ zIndex: 800 }}
						>
							<IconButton
								type="button"
								onClick={handleBackdropClose}
								aria-label="Voltar aos relatórios"
								size="large"
								sx={{
									minWidth: 44,
									minHeight: 44,
									color: "var(--primaria)",
								}}
							>
								<MdArrowBackIos size={22} />
							</IconButton>
							<span className="text-base font-semibold text-gray-800">Detalhe</span>
						</div>
						<div className="p-3">
							{backdropConteudo}
						</div>
					</div>
				</motion.div>
			</Backdrop>
		</>
	)
}